// Idee #86 (feedback impact calculator): Decca kan zijn antwoord afsluiten met
// een marker-regel `[[suggesties: optie | optie | optie]]`. De chat toont die
// opties als antwoordknoppen; de marker zelf hoort nooit in de bubble.
// De prompt-instructie leeft in functions/decca/buildSystemPrompt.js — houd
// het formaat daar en hier gelijk.

const MAX_SUGGESTIONS = 3

// Marker aan het EINDE van het bericht, eventueel gevolgd door sluitende
// html-tags/witruimte (het model plakt de regel soms in een <p>).
//
// Het voorvoegsel 'suggesties:' is optioneel. Het model laat het regelmatig
// weg, en dan bleef de hele marker als ruwe tekst in de bubble staan — precies
// het enige wat deze helper moet voorkomen. Zonder voorvoegsel eisen we wel een
// scheidingsteken '|', zodat gewone tekst tussen dubbele haken tekst blijft.
const TRAILING_MARKER =
    /\[\[\s*(?:suggesties:([^\]]*)|([^\]]*\|[^\]]*))\]\]\s*(?:<\/[a-z0-9]+>\s*)*$/i

/**
 * @param {string|null|undefined} raw - De (gestreamde) berichttekst van Decca.
 * @returns {{text: string, suggestions: string[]}} Tekst zonder marker + de opties (max 3).
 */
const extractSuggestions = (raw) => {
    if (typeof raw !== 'string' || raw === '') return { text: '', suggestions: [] }

    const match = TRAILING_MARKER.exec(raw)
    if (!match) return { text: raw, suggestions: [] }

    const suggestions = (match[1] ?? match[2] ?? '')
        .split('|')
        .map((s) => s.trim())
        .filter(Boolean)
        .slice(0, MAX_SUGGESTIONS)

    // Strip de marker; een omhullende tag die daardoor leeg achterblijft
    // (bv. `<p>[[suggesties: …]]</p>`) verdwijnt mee.
    const text = raw
        .slice(0, match.index)
        .replace(/<([a-z0-9]+)>\s*$/i, '')
        .trim()

    return { text, suggestions }
}

export default extractSuggestions
